/* Wohin und wie hoch eine Ausklapp-Fläche darf — gemeinsam für Select und
   MultiSelect, damit sich die beiden nicht auseinanderentwickeln.

   Bisher ging die Fläche immer nach unten und immer bis 320 px. Stand das
   Auswahlfeld am Seitenende, schnitt der Fensterrand die Liste ab (Issue
   #67). Jetzt entscheidet der vorhandene Platz: ist unter dem Auslöser
   weniger als MIN und darüber mehr, klappt die Fläche nach oben; und die
   Höhe wird auf den Platz begrenzt, damit die Liste scrollt statt aus dem
   Bild zu laufen.

   GAP ist der Abstand zum Auslöser (--sp-1), EDGE die Luft zum Fensterrand,
   MAX die Wunschhöhe (dieselbe wie die max-height im Stylesheet), MIN die
   Höhe, unter der Ausklappen nach unten nichts mehr bringt. */
const GAP = 4;
const EDGE = 8;
const MAX_H = 320;
const MIN_H = 160;

export function popupPlacement(rect, viewportHeight) {
  const below = viewportHeight - rect.bottom - GAP - EDGE;
  const above = rect.top - GAP - EDGE;
  const flip = below < MIN_H && above > below;
  const space = flip ? above : below;
  return {
    left: rect.left,
    width: rect.width,
    flip,
    /* Nie unter MIN: eine Liste, die auf 20 px zusammenfällt, ist unbenutzbar.
       Dann ragt sie lieber etwas über die gedachte Kante hinaus. */
    maxHeight: Math.max(MIN_H, Math.min(MAX_H, space)),
    top: flip ? undefined : rect.bottom + GAP,
    bottom: flip ? viewportHeight - rect.top + GAP : undefined,
  };
}

export default popupPlacement;
